
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {PushNotificationTokenUnRegisterResponse} from './PushNotificationTokenUnRegisterResponse';

/**
 * PushNotificationTokenUnRegisterRequest struct
 */
class PushNotificationTokenUnRegisterRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!string=} deviceType
   * @param {!string=} deviceId
   * @constructor
   */
  constructor (parent = new Request(), deviceType = '', deviceId = '') {
    super()
    super.copy(parent)
    this.DeviceType = deviceType
    this.DeviceId = deviceId
  }

  /**
   * Copy struct (shallow copy)
   * @this {!PushNotificationTokenUnRegisterRequest}
   * @param {!PushNotificationTokenUnRegisterRequest} other Other struct
   * @returns {!PushNotificationTokenUnRegisterRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.DeviceType != null) {
      this.DeviceType = other.DeviceType
    } else {
      this.DeviceType = null
    }
    if (other.DeviceId != null) {
      this.DeviceId = other.DeviceId
    } else {
      this.DeviceId = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!PushNotificationTokenUnRegisterRequest}
   * @returns {!PushNotificationTokenUnRegisterRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new PushNotificationTokenUnRegisterRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new PushNotificationTokenUnRegisterRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!PushNotificationTokenUnRegisterRequest}
   * @param {!PushNotificationTokenUnRegisterRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof PushNotificationTokenUnRegisterRequest)) {
      throw new TypeError('Instance of PushNotificationTokenUnRegisterRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!PushNotificationTokenUnRegisterRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      DeviceType: ((this.DeviceType != null) ? this.DeviceType : null),
      DeviceId: ((this.DeviceId != null) ? this.DeviceId : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return PushNotificationTokenUnRegisterRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!PushNotificationTokenUnRegisterRequest} other Object value
   * @returns {!PushNotificationTokenUnRegisterRequest} Created struct
   */
  static fromObject (other) {
    return new PushNotificationTokenUnRegisterRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!PushNotificationTokenUnRegisterRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return PushNotificationTokenUnRegisterRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!PushNotificationTokenUnRegisterRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5557
  }
}

export { PushNotificationTokenUnRegisterRequest };

/**
 * Fast Binary Encoding PushNotificationTokenUnRegisterRequest field model
 */
class FieldModelPushNotificationTokenUnRegisterRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.DeviceType = new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.DeviceId = new fbe.FieldModelString(buffer, this.DeviceType.fbeOffset + this.DeviceType.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.DeviceType.fbeSize + this.DeviceId.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.DeviceType.fbeExtra + this.DeviceId.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelPushNotificationTokenUnRegisterRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5557
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.DeviceType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DeviceType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DeviceType.fbeSize

    if ((fbeCurrentSize + this.DeviceId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DeviceId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DeviceId.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {!PushNotificationTokenUnRegisterRequest} fbeValue Default value, defaults is new PushNotificationTokenUnRegisterRequest()
   * @returns {!PushNotificationTokenUnRegisterRequest} PushNotificationTokenUnRegisterRequest value
   */
  get (fbeValue = new PushNotificationTokenUnRegisterRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {!PushNotificationTokenUnRegisterRequest} fbeValue PushNotificationTokenUnRegisterRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.DeviceType.fbeSize) <= fbeStructSize) {
      fbeValue.DeviceType = this.DeviceType.get()
    } else {
      fbeValue.DeviceType = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DeviceType.fbeSize

    if ((fbeCurrentSize + this.DeviceId.fbeSize) <= fbeStructSize) {
      fbeValue.DeviceId = this.DeviceId.get()
    } else {
      fbeValue.DeviceId = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DeviceId.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {!PushNotificationTokenUnRegisterRequest} fbeValue PushNotificationTokenUnRegisterRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelPushNotificationTokenUnRegisterRequest}
   * @param {PushNotificationTokenUnRegisterRequest} fbeValue PushNotificationTokenUnRegisterRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.DeviceType.set(fbeValue.DeviceType)
    this.DeviceId.set(fbeValue.DeviceId)
  }
}

export { FieldModelPushNotificationTokenUnRegisterRequest };

/**
 * Fast Binary Encoding PushNotificationTokenUnRegisterRequest model
 */
class PushNotificationTokenUnRegisterRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelPushNotificationTokenUnRegisterRequest(this.buffer, 4)
  }

  /**
   * Get the PushNotificationTokenUnRegisterRequest model
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @returns {!FieldModelPushNotificationTokenUnRegisterRequest} model PushNotificationTokenUnRegisterRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return PushNotificationTokenUnRegisterRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelPushNotificationTokenUnRegisterRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @param {!PushNotificationTokenUnRegisterRequest} value PushNotificationTokenUnRegisterRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @param {!PushNotificationTokenUnRegisterRequest} value PushNotificationTokenUnRegisterRequest value, defaults is new PushNotificationTokenUnRegisterRequest()
   * @return {!object} Deserialized PushNotificationTokenUnRegisterRequest value and its size
   */
  deserialize (value = new PushNotificationTokenUnRegisterRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new PushNotificationTokenUnRegisterRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new PushNotificationTokenUnRegisterRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!PushNotificationTokenUnRegisterRequestModel}
   * @param {!number} prev Previous PushNotificationTokenUnRegisterRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { PushNotificationTokenUnRegisterRequestModel };
PushNotificationTokenUnRegisterRequest.__has_response = true;
PushNotificationTokenUnRegisterRequest.__response_class = PushNotificationTokenUnRegisterResponse;
